import { BrandLogo } from "../layout/BrandLogo";

// Pure SVG "premium gift bag" illustration for the Offers tile and the
// exclusive-deals panel — no external image asset, so nothing to break.
// The monogram badge reuses the real brand mark rather than inventing new
// artwork, so it stays accurate if the admin ever changes the logo.
export function GiftBagVisual({ className }: { className?: string }) {
  return (
    <div className={`relative ${className ?? ""}`} aria-hidden>
      <svg viewBox="0 0 120 140" className="h-full w-full">
        <defs>
          <linearGradient id="giftBagBody" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#2b2b34" />
            <stop offset="100%" stopColor="#0c0c11" />
          </linearGradient>
          <linearGradient id="giftBagGold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#f3d999" />
            <stop offset="100%" stopColor="#b8873a" />
          </linearGradient>
        </defs>
        <path
          d="M40 44 C40 18, 80 18, 80 44"
          fill="none"
          stroke="url(#giftBagGold)"
          strokeWidth="3.5"
          strokeLinecap="round"
        />
        <path d="M22 48 L98 48 L90 134 L30 134 Z" fill="url(#giftBagBody)" stroke="rgba(220,182,98,0.35)" strokeWidth="1" />
        <path d="M22 48 L98 48 L94 60 L26 60 Z" fill="rgba(255,255,255,0.06)" />
        <g fill="#f3d999">
          <path
            d="M102 26 l2.4 5.6 5.6 2.4 -5.6 2.4 -2.4 5.6 -2.4 -5.6 -5.6 -2.4 5.6 -2.4 z"
            opacity="0.9"
          />
          <circle cx="16" cy="66" r="1.6" opacity="0.8" />
          <circle cx="108" cy="76" r="1.3" opacity="0.7" />
          <path
            d="M12 20 l1.6 3.8 3.8 1.6 -3.8 1.6 -1.6 3.8 -1.6 -3.8 -3.8 -1.6 3.8 -1.6 z"
            opacity="0.7"
          />
        </g>
      </svg>
      <div className="absolute left-1/2 top-[62%] -translate-x-1/2 -translate-y-1/2 h-8 w-8 sm:h-9 sm:w-9 rounded-full bg-[#0c0c11] border border-[#dcb662]/60 flex items-center justify-center overflow-hidden">
        <BrandLogo variant="icon" forceTheme="dark" className="h-4 w-4 sm:h-5 sm:w-5 object-contain" />
      </div>
    </div>
  );
}
